module.exports = __webpack_public_path__ + "img/logo.cec84936.png";